import React from 'react';
import { Badge, Stack } from 'react-bootstrap';

const AppliedFilters = ({
  filters,
  statuses = [],
  purposeOptions = [],
  typeOptions = [],
  priorities = [],
  projectUsers = [],
  modules = [],
  setFilters,
  tab,
  labels = [],
  testSuites = [],
}) => {
  const LABEL_MAP = {
    owner: tab !== 'cycles' ? 'Author' : 'Owner',
    technologyLayer: 'Technology Layer',
    cloudDevice: 'Cloud Device',
    isAutomationNeeded: 'Candidate for Automation',
    isAutomated: 'Is Automated',
    testSuites: 'Test Suites',
  };

  const VALUE_EXTRACTORS = {
    status: (value) => statuses.find((s) => s.id === value)?.name,
    type: (value) => typeOptions.find((s) => s.id === value)?.name,
    purpose: (value) => purposeOptions.find((s) => s.id === value)?.name,
    priority: (value) => priorities.find((s) => s.id === value)?.name,

    owner: (value) =>
      (Array.isArray(value) ? value : [value])
        .map((id) => projectUsers.find((u) => u.id === id)?.full_name || id)
        .join(', '),

    module: (value) =>
      value.map((id) => modules.find((m) => m.id === id)?.name || id).join(', '),

    labels: (value) =>
      value.map((id) => labels.find((l) => l.id === id)?.name || id).join(', '),

    testSuites: (value) =>
      value.map((id) => testSuites.find((s) => s.id === id)?.name || id).join(', '),
  };

  const resolveValue = (key) => {
    const value = filters[key];
    if (!value || value === 'All') return '';
    if (Array.isArray(value) && value.length === 0) return '';

    return VALUE_EXTRACTORS[key]?.(value) ??
      (Array.isArray(value) ? value.join(', ') : value);
  };

  const resolveLabel = (key) =>
    LABEL_MAP[key] ?? key.charAt(0).toUpperCase() + key.slice(1);

  const handleClose = (key) => {
    setFilters({
      ...filters,
      [key]: Array.isArray(filters[key]) ? [] : 'All',
    });
  };

  return (
    <Stack direction="horizontal" gap={2} style={{ flexWrap: 'wrap', rowGap: '10px' }}>
      {Object.keys(filters).map((key) => {
        const value = resolveValue(key);
        if (!value) return null;
        return (
          <Badge
            key={key}
            bg="success"
            className="me-2"
            style={{
              padding: '5px 10px',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              maxWidth: '100%',
            }}
          >
            <span style={{ fontWeight: 500, lineHeight: 1.2, textAlign: 'left' }}>
              {resolveLabel(key)}: {value}
            </span>
            <span
              style={{
                cursor: 'pointer',
                fontSize: '14px',
                marginLeft: 'auto',
                lineHeight: 1,
              }}
              onClick={() => handleClose(key)}
              title={`Remove ${resolveLabel(key)} filter`}
            >
              &times;
            </span>
          </Badge>
        );
      })}
    </Stack>
  );
};

export default AppliedFilters;
